export function yearFromStoredReleaseDate(raw) {
  if (raw == null || raw === "") return "";
  if (typeof raw === "number" && Number.isFinite(raw)) {
    const d = new Date(raw);
    return Number.isNaN(d.getTime()) ? "" : String(d.getFullYear());
  }
  if (typeof raw === "string") {
    const s = raw.trim();
    if (!s) return "";
    if (/^\d{4}/.test(s)) return s.slice(0, 4);
    const d = new Date(s);
    if (!Number.isNaN(d.getTime())) return String(d.getFullYear());
    return s.length >= 4 ? s.slice(0, 4) : "";
  }
  if (typeof raw === "object" && raw !== null && typeof raw.toISOString === "function") {
    try {
      return String(new Date(raw.toISOString()).getFullYear());
    } catch {
      return "";
    }
  }
  return "";
}

export function optionalFiniteNumber(v) {
  if (v == null || v === "") return null;
  const n = typeof v === "number" ? v : Number(v);
  return Number.isFinite(n) ? n : null;
}
